module.exports = __webpack_public_path__ + "static/media/pageMosaic.8dd7bc1a.svg";